import { Refresh } from '@mui/icons-material';
import React from 'react';
import { Button, Dropdown, Stack } from 'react-bootstrap';
import { TableRefreshButton } from './CustomButtons';

export const SecondaryTabsTestCases = ({
  handleOpenTestCaseModal,
  isSelectedItems,
  handleArchiveTestcase,
  showArchived,
  handleCloneTestcase,
  setShowArchived,
  setShowConfirmationModal,
  handleModalShow,
  fetchTestCases,
  handleOpenExportModal,
  setShowArchiveWarning,
  handleBulkEditModal,
}) => {
  if (showArchived) {
    return (
      <Stack direction="horizontal" gap={2}>
        <Button
          variant="primary"
          onClick={setShowArchived}
          title="Click to hide archived test cases and show others">
          Show all
        </Button>
        <Button
          variant="outline-secondary"
          onClick={() => handleArchiveTestcase('unarchived')}
          disabled={!isSelectedItems}
          title={
            !isSelectedItems
              ? 'Select test cases to perform this action'
              : 'Unarchive selected test cases'
          }>
          Unarchive
        </Button>
        <Button
          variant="outline-secondary"
          onClick={() => setShowConfirmationModal(true)}
          disabled={true}
          title='This action has been disabled'
          // disabled={!isSelectedItems}
          // title={
          //   !isSelectedItems
          //     ? 'Select test cases to perform this action'
          //     : undefined
          // }
          >
          Delete
        </Button>
      </Stack>
    );
  }
  return (
    <Stack direction="horizontal" gap={2}>
      <Button variant="primary" onClick={handleOpenTestCaseModal}>
        + Add New
      </Button>
      {/* <Button
        variant="outline-secondary"
        disabled={!isSelectedItems}
        onClick={() => {
          setShowArchiveWarning(true);
        }}
        title={
          !isSelectedItems
            ? 'Select test cases to perform this action'
            : 'Archive'
        }>
        Archive
      </Button> */}
      <Button
        variant="outline-secondary"
        disabled={!isSelectedItems}
        onClick={() => {
          handleBulkEditModal(true);
        }}
        title={
          !isSelectedItems
            ? 'Select test cases to perform this action'
            : 'Bulk Edit'
        }>
        Bulk Edit
      </Button>
      <Button
        variant="outline-secondary"
        disabled={!isSelectedItems}
        onClick={handleCloneTestcase}
        title={
          !isSelectedItems
            ? 'Select test cases to perform this action'
            : 'Clone'
        }>
        Clone
      </Button>
      <Button
        variant="outline-secondary"
        onClick={setShowArchived}
        title="Click to show archived test cases">
        Show archived
      </Button>
      <Dropdown>
        <Dropdown.Toggle variant="outline-secondary" id="more-dropdown">
          More
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => {setShowArchiveWarning(true)}} title={
          !isSelectedItems
            ? 'Select test cases to perform this action'
            : 'Archive test cases'
            } disabled={!isSelectedItems}>
            Archive
          </Dropdown.Item>
          <Dropdown.Item onClick={handleModalShow} title="Import from CSV">
            Import from CSV
          </Dropdown.Item>
          <Dropdown.Item onClick={handleOpenExportModal} title="Export to CSV">
            Export to CSV
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <Button
        variant="outline-secondary"
        className="remove-focus"
        onClick={fetchTestCases}
        title="Click to refresh the list">
        <Refresh color={'#6c757d'} size={'20px'} />
      </Button>
    </Stack>
  );
};

export const SecondaryTabsTestCycles = ({
  handleOpenTestCycleModal,
  isSelectedItems,
  handleCloneTestcycle,
  setShowConfirmationModal,
  refreshData,
}) => {
  return (
    <Stack direction="horizontal" gap={2}>
      <Button
        variant="primary"
        title="Add new test cycle"
        onClick={handleOpenTestCycleModal}>
        + New Test Cycle
      </Button>
      <Button
        variant="outline-secondary"
        disabled={isSelectedItems !== 1}
        onClick={handleCloneTestcycle}
        title={
          isSelectedItems === 1
            ? 'Clone'
            : 'Select one test cycle to perform this action'
        }>
        Clone
      </Button>

      <Button
        variant="outline-secondary"
        disabled={!isSelectedItems}
        onClick={() => setShowConfirmationModal(true)}
        title={
          !isSelectedItems
            ? 'Select test cycles to perform this action'
            : 'Delete'
        }>
        Delete
      </Button>
       <TableRefreshButton refreshData={refreshData} />
    </Stack>
  );
};

export const SecondaryTabsTestPlans = ({
  handleOpenTestPlanModal,
  isSelectedItems,
}) => {
  return (
    <Stack direction="horizontal" gap={2}>
      <Button
        variant="primary"
        title="Add new test plan"
        onClick={handleOpenTestPlanModal}>
        + New Test Plan
      </Button>

      <Button
        variant="outline-secondary"
        disabled={!isSelectedItems}
        title={
          !isSelectedItems
            ? 'Select test plans to perform this action'
            : 'Delete test plan'
        }>
        Delete
      </Button>
    </Stack>
  );
};
